<template>
    <div>
        <button
            type="button"
            :disabled="disabled"
            :title="disabled ? 'Du kan inte redigera anslutningsgraden när det är konverterat till ett projekt' : null"
            class="btn btn-md is-ghost mt-lg ml-auto"
            @click="$modal.show('edit-connection-statistics')"
        >
            Redigera
        </button>

        <adaptive-form-modal
            v-if="! disabled"
            name="edit-connection-statistics"
            primary-button-text="Spara"
            primary-button-class="is-primary"
            title="Anslutningsgrad"
            :redirect-to="route('admin.prospects.show', prospect)"
            method="patch"
            :action="route('admin.prospects.connectionStatistics.update', prospect)"
        >
            <text-input
                v-model.number="connectionStatistics.total_count"
                name="total_count"
                :required="true"
                label="Adresser totalt"
            />

            <text-input
                v-model.number="connectionStatistics.unsignable_count"
                name="unsignable_count"
                :required="true"
                label="Har fiber"
            />
        </adaptive-form-modal>
    </div>
</template>

<script>
    export default {
        props: {
            prospect: {
                type: Object,
                required: true,
            },
            disabled: {
                required: true,
                type: Boolean,
            },
        },
        computed: {
            connectionStatistics() {
                if (this.prospect.connection_statistics) {
                    return this.prospect.connection_statistics;
                }

                return {
                    total_count: 0,
                    unsignable_count: 0,
                };
            },
        },
    };
</script>